// extracted by mini-css-extract-plugin
export default {"button":"button--f8wvB","has_animation":"has_animation--ySUfF","adjustment":"adjustment--HmWRr","icon":"icon--VMeHR","fadeSlideUp":"fadeSlideUp--u62Am"};